import { render, staticRenderFns } from "./Forgot.vue?vue&type=template&id=404092b0&scoped=true"
import script from "./Forgot.vue?vue&type=script&lang=js"
export * from "./Forgot.vue?vue&type=script&lang=js"
import style0 from "./Forgot.vue?vue&type=style&index=0&id=404092b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404092b0",
  null
  
)

export default component.exports